import { DECK_ORDER, deckLook } from './decks';

/**
 * Рубашка карточки. Тап по ней — единственный жест на экране: карта
 * переворачивается, и до этого момента текста в разметке нет вовсе.
 *
 * Полоса из четырёх цветов колод сверху — обещание, а не подсказка: какая
 * именно колода вышла, видно только на ребре переворота.
 */
export function CardBack() {
  return (
    <div className="relative flex min-h-draw flex-1 flex-col justify-between gap-6 border-2 border-acc bg-ground bg-hatch-acc">
      <div className="flex h-3 w-full">
        {DECK_ORDER.map((deck) => (
          <span key={deck} className={`flex-1 ${deckLook(deck).bar}`} />
        ))}
      </div>

      <span aria-hidden className="animate-breathe self-center text-sign">
        🤡
      </span>

      <p className="p-4 text-meta uppercase tracking-widest text-mute">Рубашка · тап</p>
    </div>
  );
}
